export default "{{ content.text }}\n<section class=\"col-10 image-question\">\n    <img [src]=\"content.image\" alt=\"\" />\n</section>\n";